declare namespace $ {

	type $mol_view__sub_ink_currency_select_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_ink_currency_select_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_ink_currency_select_3 = $mol_type_enforce<
		ReturnType< $ink_currency_select['item_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_ink_currency_select_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_list__rows_ink_currency_select_5 = $mol_type_enforce<
		ReturnType< $ink_currency_select['filtered'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_link__sub_ink_currency_select_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_ink_currency_select_7 = $mol_type_enforce<
		({ 
			'type': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_search__query_ink_currency_select_8 = $mol_type_enforce<
		ReturnType< $ink_currency_select['filter'] >
		,
		ReturnType< $mol_search['query'] >
	>
	export class $ink_currency_select extends $mol_page {
		item_arg( id: any): Record<string, any>
		item_name( id: any): string
		Item_name( id: any): $mol_view
		item_symbol( id: any): string
		Item_symbol( id: any): $mol_view
		Item( id: any): $mol_link
		filtered( ): readonly(any)[]
		Presets( ): $mol_list
		Close_icon( ): $mol_icon_close
		Close_list( ): $mol_link
		filter( next?: string ): string
		Filter( ): $mol_search
		type( ): string
		input_title( ): string
		output_title( ): string
		body( ): readonly(any)[]
		tools( ): readonly(any)[]
		foot( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=select.view.tree.d.ts.map